export const clinicalFields = [
  ["medicationName", "Medication name"], ["genericName", "Generic name"], ["brandName", "Brand name"],
  ["dosage", "Dose"], ["doseUnit", "Dose unit"], ["strengthAmount", "Strength"], ["strengthUnit", "Strength unit"],
  ["route", "Route"], ["frequency", "Frequency"], ["medicationForm", "Medication form"],
  ["quantityAmount", "Expected quantity"], ["quantityUnit", "Quantity unit"],
  ["indication", "Indication"], ["instructions", "Instructions"],
  ["maxDailyDoseAmount", "Maximum daily dose"], ["maxDailyDoseUnit", "Maximum daily dose unit"],
  ["prnReason", "As-needed reason"], ["holdParameters", "Hold parameters"],
];
export const fieldsFrom = (record) => ({ ...Object.fromEntries(clinicalFields.map(([key]) => [key, record[key] || ""])), prn: Boolean(record.prn) });
export const reviewStatus = (record) => {
  const details = record.extractedMedicationDetails || {};
  const resolution = details.adminReview?.resolution || {};
  if (details.needsReReview) return "Re-review required";
  if (record.status === "MEDICATION_PENDING_ADF_APPROVAL") return "Forwarded to Ocare";
  if (resolution.onHold || resolution.identityAction === "HOLD" || Object.values(resolution.matches || {}).some(item => item.action === "HOLD")) return "On hold";
  return "Needs review";
};
export const normalizedValue = (s) => String(s || "").normalize("NFKD").replace(/\p{M}/gu, "").toLowerCase().replace(/[^\p{L}\p{N}]/gu, "");
export function unresolvedReasons(record, fields, resolution) {
  const report = record.extractedMedicationDetails?.review || {};
  const reasons = [];
  if (report.identityMismatch) reasons.push("This document belongs to a different resident. Discard it and upload the correct document.");
  if (resolution.onHold) reasons.push("Resolve the clarification and release this prescription from hold.");
  if (["medicationName", "dosage", "doseUnit", "route", "frequency"].some(key => !String(fields[key] || "").trim())) reasons.push("Complete the required medication fields.");
  if (report.identityWarning && (resolution.identityAction !== "VERIFIED_SAME_PATIENT" || !resolution.identityNote?.trim()
    || !normalizedValue(resolution.verifiedPatientName) || normalizedValue(resolution.verifiedPatientName) !== normalizedValue(report.residentName)
    || !resolution.verifiedDateOfBirth || resolution.verifiedDateOfBirth !== report.residentDateOfBirth)) reasons.push("Resolve patient identity and date of birth.");
  if (record.extractedMedicationDetails?.extractionWarnings && !resolution.extractionNote?.trim()) reasons.push("Resolve the extraction warnings.");
  for (const match of report.medicationMatches || []) {
    if (match.kind === "EXACT_MATCH") continue;
    const choice = resolution.matches?.[match.medicationId];
    if (choice?.action !== "UPDATE_EXISTING" || !choice?.note?.trim()) reasons.push(`Resolve the comparison with ${match.medicationName}.`);
  }
  if ((report.medicationMatches || []).length > 1) reasons.push("Reconcile multiple active duplicates before forwarding.");
  if (!resolution.documentVerified) reasons.push("Verify the final order against the source document.");
  return reasons;
}
